<template>
  <!-- <div class="app-container"> -->
  <div class="">
    <el-row :gutter="32">
      <el-col :xs="24" :sm="24" :lg="16">
        <div class="leftone" :style="'height:' + height">

          <div class="head">评分标准</div>

          <div class="text">
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;">
              <span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">针对AI应用系统的服务器配置、部署和数据备份需求进行系统性规划，确保系统稳定运行和数据安全，具体包括：
              </span>
            </p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;">
              <span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">1.服务器选型与配置方案：</span>
            </p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(1)硬件配置规划：CPU性能配置、内存容量规划、存储空间配置、网络带宽需求、服务器扩展能力；
              </span></p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(2)操作系统选型：系统版本选择、安全补丁策略、系统优化配置、系统监控方案；
              </span></p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(3)数据库配置：数据库类型选择、数据库参数优化、数据库性能调优、连接池配置；</span>
            </p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(4)中间件配置：应用服务器选型、缓存服务配置、消息队列配置、负载均衡设置；</span>
            </p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">2.系统部署方案：</span>
            </p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(1)部署架构设计：应用服务器集群方案、数据库集群方案、负载均衡架构、容灾备份架构；</span>
            </p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(2)网络环境配置：网络拓扑设计、安全域划分、防火墙策略、访问控制策略；</span>
            </p>
            <p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(3)应用系统部署：智能报告模块部署、知识库模块部署、智能问数模块部署、系统集成配置；</span>
            </p>
            <p><span
                style="color: rgba(134,144,156,1);font-size: 14px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(4)系统监控部署：性能监控配置、告警阈值设置、日志收集方案、监控可视化配置；</span>
            </p>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :lg="8">
        <div class="rightone flex-col" :style="'height:' + height">

          <div class="style__StyledImageWrapper-sc-19t79un-0 jintaJ image-wrapper"
            style="width: 100%; height: 80%; border-style: none; border-radius: inherit; overflow: hidden; box-shadow: none;">
            <div class="image-container" style="background-color: inherit;"><img class="img"
                src="@/assets/images/v2_t1n47c.png" draggable="false" alt="image"
                style="width: 318px; height: 282.36px; display: block; ">
            </div>
          </div>
         <el-button size="small" type="primary" @click="submitFill">评分自测</el-button>

        </div>
      </el-col>

    </el-row>
  </div>
</template>

<script>
import { listSelfassessment, getSelfassessment, delSelfassessment, addSelfassessment, updateSelfassessment } from "@/api/intelligentinspection/selfassessment";

export default {
  name: "Selfassessment",
  data() {
    return {
      height: document.documentElement.clientHeight - 325 + "px;",

    };
  },
  created() {
    // this.getList();
  },
  methods: {

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加标书评分自测";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getSelfassessment(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改标书评分自测";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updateSelfassessment(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addSelfassessment(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除标书评分自测编号为"' + pids + '"的数据项？').then(function () {
        return delSelfassessment(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => { });
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('intelligentinspection/selfassessment/export', {
        ...this.queryParams
      }, `selfassessment_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
<style scoped lang="scss">
.leftone {
  width: 100%;
  height: 100%;
  /* height: 500px; */
  z-index: 153;
  opacity: 1;
  background: rgb(255, 255, 255);
  box-shadow: rgba(127, 131, 247, 0.62) 0px 2px 6px 0px;
  border-color: rgb(187, 187, 187);
  border-style: solid;
  border-width: 1px;
  border-radius: 14px;
overflow-y: auto;
  .head {
    font-size: 16px;
    font-weight: 550;
    margin-top: 22px;
    margin-left: 44px;
  }

  .text {
    margin-left: 39px;
  }
}
.rightone{
  display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
</style>
